// componnents/UI/ProductSkeleton.jsx
import React from 'react';
import './UI.css';

const ProductSkeleton = ({ count = 8 }) => {
  return (
    <>
      {[...Array(count)].map((_, i) => (
        <div 
          key={i} 
          className="product-skeleton"
          style={{ 
            animationDelay: `${i * 0.05}s`,
            opacity: 0 
          }}
        >
          <div className="skeleton-image"></div>
          <div className="skeleton-content">
            <div className="skeleton-text"></div>
            <div className="skeleton-text short"></div>
            <div className="skeleton-text shorter"></div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ProductSkeleton;

